import { Injectable, inject } from '@angular/core';
import {
  ConfirmCardSetupData,
  PaymentIntentResult,
  SetupIntentResult,
  Stripe,
  StripeElementsOptionsClientSecret,
} from '@stripe/stripe-js';
import { AppConfigService } from '../providers/config.service';
import { DataLoaderService } from './data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  private stripe: Stripe;
  private config = inject(AppConfigService);
  private loader = inject(DataLoaderService);

  private async init() {
    return this.loader.get('stripe', async () => this.setKey(this.config.stripePublishableKey));
  }

  private async setKey(key: string) {
    const resp = await import('@stripe/stripe-js');
    this.stripe = await resp.loadStripe(key);
    return true;
  }

  public async confirmCardSetup(clientSecret: string, options: ConfirmCardSetupData): Promise<SetupIntentResult> {
    await this.init();
    return this.stripe.confirmCardSetup(clientSecret, options);
  }

  public async confirmCardPayment(
    clientSecret: string,
    options: { payment_method: string }
  ): Promise<PaymentIntentResult> {
    await this.init();
    return this.stripe.confirmCardPayment(clientSecret, options);
  }

  public async elements(options: StripeElementsOptionsClientSecret) {
    await this.init();
    return this.stripe.elements(options);
  }
}
